export const BLOCK_UNBLOCK_SLOT = "BLOCK_UNBLOCK_SLOT";

export const blockUnblockSlot = ({
  sport,
  turf_number,
  date,
  location,
  block_time = [],
  unblock_time = [],
  duration = 1,
}) => ({
  type: BLOCK_UNBLOCK_SLOT,
  payload: {
    sport,
    turf_number,
    date,
    location,
    block_time,
    unblock_time,
    duration,
  },
});
